import { TaskStatusGlyph } from "@/components/ui";
import { cn } from "@/lib/cn";
import type { Task } from "@/api/tasks";
import { TaskProjectChip } from "./task-metadata-chips";

export function CalendarTaskPill({
  task,
  onSelect,
}: {
  task: Task;
  onSelect: (taskId: string) => void;
}) {
  return (
    <button
      type="button"
      onClick={(event) => {
        event.stopPropagation();
        onSelect(task.id);
      }}
      className={cn(
        "nodrag flex w-full items-center gap-1 rounded-control px-1 py-0.5 text-left hover:bg-[var(--color-interactive-hover)]",
        task.status === "done" && "text-muted",
      )}
      title={`${task.ticket_display ?? ""} ${task.title}`}
      data-task-pocket-item={task.id}
      data-testid={`calendar-pill-${task.id}`}
    >
      <TaskStatusGlyph status={task.status} size="md" neutral />
      <TaskProjectChip projectId={task.project} dotOnly />
      <span className="truncate text-appkit-small text-primary">
        {task.title}
      </span>
    </button>
  );
}
